import styled from 'styled-components';
import Screen from '../../../../shared/utils/screen';

interface Props {
  x: number;
  y: number;
}

const FloatingMenuContainer = styled.div<Props>`
  cursor: pointer;
  position: fixed;
  bottom: ${(props) => props.y * Screen.widthRatio}px;
  left: ${(props) => props.x * Screen.widthRatio}px;
`;

export default FloatingMenuContainer;
